import styled, { css, keyframes } from 'styled-components'

export const ProgressBarContainer = styled.div`
  height: 10px;
  background-color: rgba(42, 94, 246, 0.1);
  border-radius: 2px;
  overflow: hidden;
  width: 100%;
`

export const ProgressContainer = styled.div`
  padding: 15px;
  margin-top: 25px;
  margin-bottom: 25px;
  border: 1px solid #e6e8eb;
  background-color: #fff;
  border-radius: 6px;
  width: 100%;
`

const move = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 30px 30px;
  }
`

export const ProgressBar = styled.div<{ width: number }>`
  ${({ width }) => css`
    width: ${width}%;
    height: 100%;
    background-color: #2a5ef6;

    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );

    background-size: 30px 30px;
    animation: ${move} 2s linear infinite;
    animation-play-state: running;
  `}
`

export const Dimmer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  z-index: 10;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
`
